export default {
    name: 'Offering Summary',
    headerRow: ['OFFERING SUMMERY', null],
    rows: {
        'price': {
            name: 'Price',
            editable: false,
            nameClasses: 'font-gotham-bold font-size-10',
            styleClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = precomputedValues.pricingValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'cap-rate': {
            name: 'Cap Rate',
            editable: false,
            nameClasses: 'font-gotham-bold font-size-10',
            styleClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = parseFloat(tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'net-operating-income': {
            name: 'Net Operating Income',
            editable: false,
            nameClasses: 'font-gotham-bold font-size-10',
            styleClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = parseInt(precomputedValues.netOperatingIncome);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'proforma-cap-rate': {
            name: 'Cap Rate (Proforma)',
            editable: false,
            hidden: true,
            getComputedValue(tabs) {
                const value = tabs['pricing-tab'].tables['value'].rows['cap-rate'].valueCells[6].value;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${parseFloat(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'net-operating-income-proforma': {
            name: 'Net Operating Income (Proforma)',
            editable: false,
            hidden: true,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = parseInt(precomputedValues.netOperatingIncomeProForma);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'price-psf': {
            name: 'Price PSF',
            editable: false,
            nameClasses: 'font-gotham-bold font-size-10',
            styleClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['pricing-tab'].tables['value'].rows['value'].valueCells[3].getComputedValue(tabs, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})} PSF`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'occupancy': {
            name: 'Occupancy',
            editable: false,
            nameClasses: 'font-gotham-bold font-size-10',
            styleClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(tabs, 'first-row', precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})}%`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'year-built': {
            name: 'Year Built',
            editable: false,
            nameClasses: 'font-gotham-bold font-size-10',
            styleClasses: 'font-gotham font-size-10',
            getComputedValue(tabs) {
                const value = tabs['property-information-tab'].tables['other-information'].rows['year-built'].value;
                const displayValue = !value || isNaN(value) ? '-' : value;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'gross-leasable-area': {
            name: 'Gross Leasable Area',
            editable: false,
            nameClasses: 'font-gotham-bold font-size-10',
            styleClasses: 'font-gotham font-size-10',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = precomputedValues.totalSpace;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString()} SF`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
        'lot-size': {
            name: 'Lot Size',
            editable: false,
            nameClasses: 'font-gotham-bold font-size-10',
            styleClasses: 'font-gotham font-size-10',
            getComputedValue(tabs) {
                const value = tabs['property-information-tab'].tables['other-information'].rows['lot-size'].value;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${parseFloat(value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})} Acres`;
                return {internalValue: value, displayValue: displayValue}
            }
        },
    }
};